<template>
  <div class="form-group" :class="{'has-warning': exceedsLimit }">
    <label class="control-label" for="content-title">Title</label>
    <input
      id="content-title"
      type="text"
      :value="value"
      @input="$emit('input', $event.target.value.trim())"
      class="form-control">
    <span class="help-block" v-if="exceedsLimit">Title is more than {{ limit }} characters (<b>{{ overflowText }}</b>)</span>
  </div>
</template>

<script>
export default {
  name: 'EditTitle',
  props: {
    value: {
      type: String,
      required: true
    },
    limit: {
      type: Number,
      default: 50
    }
  },
  computed: {
    exceedsLimit() {
      return this.value.trim().length > this.limit
    },
    overflowText() {
      return this.value.trim().slice(this.limit)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
